module.exports = __webpack_public_path__ + "img/kr-product-card3-item3-step2.63cdba5.png";